<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size md_size">
            <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ $t('FIELD.GLOBAL.ETC.025') }}</i>
                </dt>
                <dd>
                    <dl class="selTarget_wrap">
                        <dd class="scroll" data-type="tree">
                            <dl class="tree_wrap noLine"><!-- search_tree 추가 -->
                                <dd>
                                    <article class="tree_group">
                                        <ul class="tree_list">
                                            <li class="active">
                                                <a href="javascript:" class="ico_tree" @click="treeClick($event)">
                                                    <span class="sr_only"></span>
                                                </a>
                                                <label class="checkbox-wrap">
                                                    <input name="checkAll" type="checkbox" @change="treeChange($event, 'all')"/>
                                                    <i class="check-icon"></i>
                                                    <em>{{ $t('FIELD.GLOBAL.ALL') }}</em>
                                                </label>
                                                <ul class="tree_sub_list">
                                                    <li v-for="item in categoryCodeList" :key="pageName + item.code">
                                                        <a href="javascript:" class="ico_tree" @click="treeClick($event, item.subCodeList)">
                                                            <span class="sr_only"></span>
                                                        </a>
                                                        <label class="checkbox-wrap">
                                                            <input
                                                                type="checkbox"
                                                                :name="item.code + '_all'"
                                                                :value="item.code"
                                                                class="region"
                                                                @change="treeChange($event, item.code)"
                                                            /><i class="check-icon"></i>
                                                            <em>{{ item.codeName }}</em>
                                                        </label>
                                                        <ul class="tree_sub_list" :key="pageName + item.code + inquiryCount">
                                                            <li v-for="subCode in item.subCodeList" :key="pageName + item.code + subCode.code">
                                                                <label class="checkbox-wrap">
                                                                    <input
                                                                        type="checkbox"
                                                                        :name="item.code"
                                                                        :value="subCode.code"
                                                                        :data-name="subCode.codeName"
                                                                        class="subsidiary"
                                                                        @change="treeChange($event, item.code, subCode.code)"
                                                                    /><i class="check-icon"></i>
                                                                    <em>{{ subCode.codeName }}</em>
                                                                </label>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </article>
                                </dd>
                            </dl>
                        </dd>
                        <dd class="btn">
                            <span>
                                <a href="javascript:" class="ico_arrow_next box" @click="btnAdd"></a>
                                <a href="javascript:" class="ico_arrow_prev box" @click="btnRemove"></a>
                            </span>
                        </dd>
                        <dd class="scroll" data-type="list">
                            <ul>
                                <li v-for="sub in subsidiaryList"
                                    :class="selSub === sub ? 'active' : ''"
                                    @click="selSubInList(sub)"
                                >{{ sub }}</li>
                            </ul>
                        </dd>
                    </dl>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_wrap_full topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="$emit('close')">{{ $t('BUTTON.GLOBAL.CANCEL') }}</a>
                            <a href="javascript:" class="btn_blue" @click="targetApply">{{ $t('BUTTON.GLOBAL.APPLY') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                          from 'vue';
import { mapActions, mapGetters }   from 'vuex';
import qs                           from 'query-string';
import axios                        from 'axios';
import api                          from '@/service';
import { SDLUtil }                  from '@/utils';

export default {
    name: 'KnowledgeTargetPopup',
    props: {
        selTargetList: {},
        isRequestSharing: { default: false },
        requesterId: {},
        rtnFunc: { type: Function }
    },
    data() {
        return {
            pageName: SDLUtil.getMsgProp('FIELD.GLOBAL.ETC.025'),
            isLoading: false,
            inquiryCount: 0,
            categoryCodeList: [],
            subsidiaryList: [],

            selSub: '',
            selSubList: [],
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            loginSystem: 'getLoginSystem',
            storeParams: 'getParams',
            userCorpCd: 'getCorpCd',
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq'
        }),
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode, additional1) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, (SDLUtil.isNull(additional1) ? this.loginNo : additional1));
            return codeResp;
        },
        categoryList(v, recursion) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'RHQ_AUTH_ACCESS_CD';
                parentCode = this.isRequestSharing ? this.requesterId : this.loginNo;
                this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.categoryCodeList = resp;
                    for (const category of this.categoryCodeList) {
                        this.categoryList(2, category.code);
                    }
                });
            } else if (v === 2) {
                codeCategoryId = 'SUB_AUTH_ACCESS_CD';
                parentCode = recursion;
                let additional1 = this.isRequestSharing ? this.requesterId : this.loginNo;
                this.getCodeComboList(parentCode, codeCategoryId, additional1).then(resp => {
                    for (const category of this.categoryCodeList) {
                        if (category.code === resp[0].parentCode) {
                            category.subCodeList = resp;
                            this.inquiryCount += 1;
                            return;
                        }
                    }
                });
            }
        },
        treeClick(e) {
            $(e.target).closest("li").on("click", function() {
                if( $(e.target).closest("li").hasClass('active') == true){
                    $(e.target).closest('li').removeClass('active');

                } else {
                    //$('.tree_list > li').removeClass('active');
                    $(e.target).closest('li').removeClass('active');
                    $(e.target).closest('li').addClass('active');
                }
            });
        },
        treeChange(e, v1, v2) {
            if(SDLUtil.nvl(v1) === 'all') {
                if ($(e.target).is(':checked')) {
                    $('input[class=region], input[class=subsidiary]').each(function(idx) {
                        $(this).prop('checked', true);
                    });

                } else {
                    $('input[class=region], input[class=subsidiary]').each(function(idx) {
                        $(this).prop('checked', false);
                    });
                }

            } else if (SDLUtil.isNull(v2)) {
                if ($(e.target).is(':checked')) {
                    $('input[name=' + v1 + ']').each(function(idx) {
                        $(this).prop('checked', true);
                    });

                } else {
                    $('input[name=' + v1 + ']').each(function(idx) {
                        $(this).prop('checked', false);
                    });
                }

                this.treeAllCheck();

            } else {
                var _$length = $('input[name=' + v1 + ']').length;
                if ($('input[name=' + v1 + ']:checked').length == _$length) {
                    $('input[name=' + v1 + '_all]').prop('checked', true);

                } else {
                    $('input[name=' + v1 + '_all]').prop('checked', false);
                }

                this.treeAllCheck();
            }
        },
        treeAllCheck() {
            var _$length = $('input[class=region], input[class=subsidiary]').length,
                _$cLength = $('input[class=region]:checked, input[class=subsidiary]:checked').length;

            if(_$length == _$cLength) {
                $('input[name=checkAll]').prop('checked', true);
            } else {
                $('input[name=checkAll]').prop('checked', false);
            }
        },
        btnAdd() {
            let subList = [];
            $('input[class=subsidiary]:checked').each(function(idx) {
                let subItem = $(this).attr('data-name');
                if(_.findIndex(this.subsidiaryList, function(s){ return s == subItem }) === -1){
                    subList.push( subItem );
                };
            });

            this.subsidiaryList = _.union(this.subsidiaryList, subList);
            // 추가 후 체크 박스 해제
            $('input[class=subsidiary]').prop('checked', false);
            $('input[class=region]').prop('checked', false);
        },
        btnRemove() {
            let self = this;
            let findIdx = _.findIndex(this.subsidiaryList, function(s){ return s == self.selSub; });
            delete this.subsidiaryList.splice(findIdx, 1);
            this.selSub = '';
        },
        targetApply() {
            this.rtnFunc(this.subsidiaryList);
            this.$emit('close');
        },
        selSubInList(sub) {
            if(this.selSub !== sub) {
                this.selSub = sub;
            }
        },
    },
    created() {
        this.subsidiaryList = this.selTargetList || [];
        this.categoryList(1);
    },
    mounted() {
        this.$nextTick( () => {
            $('.tree_list > li .ico_tree').on("click",function(){
                if( $(this).closest("li").hasClass('active') == true){
                    $(this).closest('li').removeClass('active');
                } else {
                    //$('.tree_list > li').removeClass('active');
                    $(this).closest('li').removeClass('active');
                    $(this).closest('li').addClass('active');
                }
            });
        });
    }
};
</script>
<style>
[data-type="list"] li:hover {background-color:#f4f7fe;}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/popup/KnowledgeTargetPopup.vue